module.exports = __webpack_public_path__ + "img/product-cuishou2.162f6ecd.svg";